export default __webpack_public_path__ + "static/media/na.6032f042.jpg";